import { render, staticRenderFns } from "./ServerEdit.vue?vue&type=template&id=023638c2&"
import script from "./ServerEdit.vue?vue&type=script&lang=js&"
export * from "./ServerEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServerEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports